import {Component, Input} from "@angular/core";
import {AuthService} from "../../../../../services/auth.service";
import {RootShareService} from "../../../../../services/root.shared.service";
import {FundasExam} from "../../../../../models/forms/referral/fundas.exam";
import {VisualFieldInterpretationExam} from "../../../../../models/forms/referral/visual.field.interpretation.exam";

@Component({
    selector: 'visual-field-interpretation-exam-component',
    templateUrl: './visual-field-interpretation-exam.html'
})
export class VisualFieldInterpretationExamComponent {
    @Input() fundasExam: VisualFieldInterpretationExam;

    @Input() patient: any;
    @Input() patientDocument: any;
    @Input() readOnly: Boolean = false;

    constructor(private _rootShareService: RootShareService, private _auth: AuthService) {
    }
}
